
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const MyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50:  '#000000',
      100: '#000000',
      200: '#000000',
      300: '#000000',
      400: '#6f8fd2',
      500: '#5776b0',
      600: '#4a6597',
      700: '#3e547d',
      800: '#314364',
      900: '#25324a',
      950: '#1a2333'
    }
  },
  components: {
    extend: {
      page: {
        color: '#334155',
        background: '#fff'
      }
    }
  }
});


export default MyPreset;
